import * as querystring from 'querystring'
import * as uri from 'url'
import * as jwtDecode from 'jwt-decode'

import environment from '../../environments/environment'


interface Oauth2Config {
  clientId: string
  authorizationUri: string
  redirectUri: string
}

export default class OAuth2 {
  private oauth2: Oauth2Config

  constructor() {
    this.oauth2 = {
      clientId: environment.oauth2ClientId,
      authorizationUri: environment.oauth2AuthorizeUrl,
      redirectUri: environment.oauth2RedirectUrl,
    }
  }


  /**
   * Compute a OAuth2 implicit grant type url
   *
   * @param activatedRoute The route the user tried to access before being redirected
   */
  public getAuthorizeUri(activatedRoute: string): string {
    return `${this.oauth2.authorizationUri}?${querystring.stringify({
      client_id: this.oauth2.clientId,
      response_type: 'token'
    })}&redirect_uri=${this.oauth2.redirectUri}&state=${
      new Buffer(
        JSON.stringify({
          activatedRoute: activatedRoute
        })
      ).toString('base64')}&scope=openid`
  }

  /**
   * Parse the OAuth2 token from url
   * @param url Callback url from cognito
   */
  public getToken(url: string): string {
    return this.parseHashBangArgs(uri.parse(url).hash)['id_token']
  }

  /**
   * Parse the OAuth2 token ID from url
   * @param url Callback url from cognito
   */
  public getUserId(url: string): string {
    return jwtDecode(this.parseHashBangArgs(uri.parse(url).hash)['id_token']).sub
  }

  /**
   * Parse the OAuth2 state from url
   *
   * @param url Callback url from cognito
   *
   * @return The state object in callback url
   */
  public getState(url: string): any {
    return JSON.parse(new Buffer(this.parseHashBangArgs(uri.parse(url).hash)['state'], 'base64').toString('ascii'))
  }

  /**
   * Get the activated route from state in callback url
   *
   * @param url Callback url from Cognito
   */
  public getActivatedRoute(url: string): string {
    return this.getState(url)['activatedRoute']
  }

  /**
   * Parse HashBang parameters
   *
   * @param hashParams
   *
   * @return an object (key:value) of parameters
   */
  parseHashBangArgs(hashParams: string): any {
    const vars: any = {};
    const hashes = hashParams.slice(hashParams.indexOf('#') + 1).split('&');

    for (let i = 0; i < hashes.length; i++) {
      const hash = hashes[i].split('=');

      if (hash.length > 1) {
        vars[hash[0]] = hash[1];
      } else {
        vars[hash[0]] = null;
      }
    }

    return vars;
  }
}
